const LOCALE_MAP = { pl: 'pl-PL', de: 'de-DE', cz: 'cs-CZ' };

export function calculateDeliveryDate(rangeText, locale = 'pl') {
    const roboczychMatch = rangeText.match(/(\d+)\s*dni\s*roboczych/i);
    if (roboczychMatch) {
        const days = parseInt(roboczychMatch[1], 10);
        var minDays = days;
        var maxDays = days +5;
    } else {
        const match = rangeText.match(/(\d+)\s*-\s*(\d+)/);
        if (!match) return null;
        var minDays = parseInt(match[1], 10);
        var maxDays = parseInt(match[2], 10);
    }
    const startDate = addBusinessDays(new Date(), minDays);
    const endDate = addBusinessDays(new Date(), maxDays);
    const startMonth = getMonthName(startDate, locale);
    const endMonth = getMonthName(endDate, locale);
    if (startMonth === endMonth) {
        return `${startDate.getDate()}-${endDate.getDate()} ${endMonth}`;
    }
    return `${startDate.getDate()} ${startMonth} - ${endDate.getDate()} ${endMonth}`;
}
function getEasterDate(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
}

function isPolishHoliday(date) {
    const d = new Date(date);
    const day = d.getDate();
    const month = d.getMonth();
    const year = d.getFullYear();

    const fixedHolidays = [
        { month: 0, day: 1 },
        { month: 0, day: 6 },
        { month: 4, day: 1 },
        { month: 4, day: 3 },
        { month: 7, day: 15 },
        { month: 10, day: 1 },
        { month: 10, day: 11 },
        { month: 11, day: 25 },
        { month: 11, day: 26 },
    ];

    for (const h of fixedHolidays) {
        if (month === h.month && day === h.day) return true;
    }

    const easter = getEasterDate(year);
    const easterMonday = new Date(easter);
    easterMonday.setDate(easterMonday.getDate() + 1);

    if (month === easterMonday.getMonth() && day === easterMonday.getDate()) {
        return true;
    }

    const corpusChristi = new Date(easter);
    corpusChristi.setDate(corpusChristi.getDate() + 60);

    if (month === corpusChristi.getMonth() && day === corpusChristi.getDate()) {
        return true;
    }

    return false;
}

function addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
        result.setDate(result.getDate() + 1);
        const day = result.getDay();
        if (day !== 0 && day !== 6 && !isPolishHoliday(result)) {
            added++;
        }
    }
    return result;
}
function getMonthName(date, locale = 'pl') {
    return date.toLocaleString(LOCALE_MAP[locale] || "pl-PL", { month: "long" });
}
